import { enableProdMode, importProvidersFrom, inject, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { registerLicense } from '@syncfusion/ej2-base';

import { routes } from './app/app.routes';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { BaseModule } from './app/base/base.module';
import { ThemeService } from './app/base/services/theme.service';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';

export function initializeTheme(): void {
  const themeService = inject(ThemeService);

  themeService.initialize();
}

// Registering Syncfusion license key
registerLicense(environment.syncfusionKey);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    importProvidersFrom(BaseModule),
    provideAppInitializer(initializeTheme)
  ]
})
  .catch(err => console.error(err));
